import React from "react"
import { Button, Modal } from "react-bootstrap"
import { defineMessages, FormattedMessage, injectIntl } from "react-intl"
import SimpleCustomerSelectComponent from "../components/SimpleCustomerSelectComponent"
import {
    getCustomerIdSelection,
} from "../../../state/selection/selectionSelectors"
import { connect, ConnectedProps } from "react-redux"

const messages = defineMessages({
    modal_title: {
        id: "price_list.select_customers_modal.title",
        defaultMessage: "Select Customers",
    },
    modal_back: {
        id: "price_list.bulk_create_modal.back_btn",
        defaultMessage: "Back",
    },
    modal_next: {
        id: "price_list.bulk_create_modal.next_btn",
        defaultMessage: "Next",
    }
})


type OwnProps = {
    show: boolean
    onHide: () => boolean
    onNext: () => void
    onPrev: () => void
}

const SelectCustomerModal = (props: Props) => {

    return (
        <Modal
            {...props}
            scrollable={true}
            size={"lg"}
            backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    <FormattedMessage{...messages.modal_title} />
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="p-4">
                <SimpleCustomerSelectComponent />
            </Modal.Body>

            <Modal.Footer>
                <Button
                    onClick={props.onPrev}
                    variant="secondary">
                    <FormattedMessage {...messages.modal_back} />
                </Button>

                <Button
                    onClick={props.onNext}
                    variant="primary"
                    disabled={props.numberOfCustomers < 1}>
                    <FormattedMessage {...messages.modal_next} />
                    <span>({props.numberOfCustomers})</span>
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

const mapState = (state, props: OwnProps) => {
    return {
        ...props,
        numberOfCustomers: getCustomerIdSelection(state).size,
    }
}
const mapDispatch = {}
const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>

export default connector(injectIntl(SelectCustomerModal))


// WEBPACK FOOTER //
// ./src/common/contact/modals/SelectCustomerModal.tsx